import { useRouteError } from "react-router";

import {Link} from "react-router";

const Error = () =>{
    const err = useRouteError();
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
        <h1 className="text-6xl font-bold text-red-500 mb-4">Oops!</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-2">
          Something went wrong
        </h2>
        <h3 className="text-lg text-gray-600">
          {err.status} : {err.statusText}
        </h3>
        <Link to="/">
          <button className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
            Go Back Home
          </button>
        </Link>
      </div>
    );
}

export default Error;
